import { render, staticRenderFns } from "./OaoIconCard.vue?vue&type=template&id=2f951538&scoped=true"
import script from "./OaoIconCard.vue?vue&type=script&lang=js"
export * from "./OaoIconCard.vue?vue&type=script&lang=js"
import style0 from "./OaoIconCard.vue?vue&type=style&index=0&id=2f951538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0d1d51ab4c56f75a7402f3cb98fb63e0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f951538",
  null
  
)

export default component.exports